import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminHome from "./pages/HomeAdmin";
import HomeDriver from "./pages/HomeDriver";
import DriverDeliveries from "./pages/DriverDeliveries";
import DriverPickups from "./pages/DriverPickups";
import DriverProfile from "./pages/DriverProfile";
import SellerHome from "./pages/SellerHome";
import SellerDeliveries from "./pages/SellerDeliveries";
import Totales from "./pages/Totales";
import Stores from "./pages/Stores";
import PriceLists from "./pages/PriceLists";
import Users from "./pages/Users";
import ManualLoad from "./pages/ManualLoad";
import Deliveries from "./pages/Deliveries";
import EnviosLegacy from "./pages/EnviosLegacy";
import LiquidacionesClientes from "./pages/LiquidacionesClientes";
import LiquidacionesChoferes from "./pages/LiquidacionesChoferes";
import LiquidacionesDashboard from "./pages/LiquidacionesDashboard";
import LiquidacionesHistorial from "./pages/LiquidacionesHistorial";
import ReportesOperativos from "./pages/ReportesOperativos";
import DeliveriesLoad from "./pages/DeliveriesLoad";
import LynxPack from "./pages/LynxPack";
import Performance from "./pages/Performance";
import RoutesPage from "./pages/RoutesPage";
import ColectasFijasPage from "./pages/ColectasFijasPage";
import ShelvesPage from "./pages/ShelvesPage";
import PlantaPage from "./pages/PlantaPage";
import MapaChoferesPage from "./pages/MapaChoferesPage";
import OperacionPage from "./pages/OperacionPage";

import AdminLayout from "./Layouts/AdminLayout";
import DriverLayout from "./Layouts/DriverLayout";
import SellerLayout from "./Layouts/SellerLayout";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import RequireFinanceAccess from "./components/auth/RequireFinanceAccess";
import RequireReportsAccess from "./components/auth/RequireReportsAccess";


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route element={<ProtectedRoute allowedRoles={["ADMIN"]} />}>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminHome />} />

            <Route path="envios" element={<Deliveries />} />
            <Route path="envios/legacy" element={<EnviosLegacy />} />
            <Route path="envios/carga" element={<DeliveriesLoad />} />
<Route path="envios/lynxpack" element={<LynxPack />} />
            <Route
              path="envios/etiquetas"
              element={
                <div style={{ padding: "24px", color: "var(--text-primary)" }}>
                  Impresión de etiquetas
                </div>
              }
            />

            <Route path="recorridos" element={<RoutesPage />} />
            <Route path="recorridos/fijas" element={<ColectasFijasPage />} />
            <Route path="envios/rutear" element={<Navigate to="/admin/recorridos" replace />} />

            <Route path="deposito/planta" element={<PlantaPage />} />
            <Route path="deposito/estanterias" element={<ShelvesPage />} />
            <Route path="choferes/mapa" element={<MapaChoferesPage />} />
            <Route path="operacion" element={<OperacionPage />} />

            <Route path="performance" element={<Performance />} />

            <Route element={<RequireFinanceAccess />}>
              <Route path="liquidaciones/dashboard" element={<LiquidacionesDashboard />} />
              <Route path="liquidaciones/historial" element={<LiquidacionesHistorial />} />
              <Route path="liquidaciones/clientes" element={<LiquidacionesClientes />} />
              <Route path="liquidaciones/choferes" element={<LiquidacionesChoferes />} />
            </Route>
            <Route path="liquidaciones/carga-manual" element={<ManualLoad />} />
            <Route path="liquidaciones/totales" element={<Totales />} />

            <Route element={<RequireReportsAccess />}>
              <Route path="reportes-operativos" element={<ReportesOperativos />} />
            </Route>

            <Route path="stores" element={<Stores />} />
            <Route path="users" element={<Users />} />

            <Route path="sistema/listas-de-precios" element={<PriceLists />} />

            <Route path="dashboard" element={<Dashboard />} />
            <Route path="totales" element={<Totales />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["DRIVER"]} />}>
          <Route path="/driver" element={<DriverLayout />}>
            <Route index element={<HomeDriver />} />
            <Route path="deliveries" element={<DriverDeliveries />} />
            <Route path="pickups" element={<DriverPickups />} />
            <Route path="profile" element={<DriverProfile />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={["SELLER"]} />}>
          <Route path="/seller" element={<SellerLayout />}>
            <Route index element={<SellerHome />} />
            <Route path="envios" element={<SellerDeliveries />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;